import { InformationCircleIcon } from '@heroicons/react/20/solid';
import React from 'react';
import { CalendarRoomDisplayType } from '@app/model/company_hotel/CalendarRoomDisplayType';
import Utilities from '@util/Utilities';
import { useSelectedCompanyHotel } from '@app/site/secured/rateshopper/rates/provider/useSelectedCompanyHotel';
import { MarketStateStatDateCompetitorSnapshot } from '@app/model/market_state/MarketStateStatDateCompetitorSnapshot';
import HotelRoomMappingTooltip
	from '@app/site/secured/rateshopper/rates/settings/page/room-mapping/component/HotelRoomMappingTooltip';

export const MarketStateCalendarDayTableRowRoomIndicator: React.FunctionComponent<{
	marketStatDateCompetitorSnapshot: MarketStateStatDateCompetitorSnapshot
}> = ({ marketStatDateCompetitorSnapshot }) => {

	const { companyHotel } = useSelectedCompanyHotel();

	const lowestItem = marketStatDateCompetitorSnapshot.getLowestItemForRoom();
	const room = lowestItem.findRoom(companyHotel);

	const id = lowestItem.roomId + '_tooltip';

	let displayName;
	if (companyHotel.settings.calendar.calendarDayRoomDisplayType === CalendarRoomDisplayType.ROOM_MAPPING) {
		displayName = Utilities.snakeCaseToWords(room.roomMappingName);
	} else if (companyHotel.settings.calendar.calendarDayRoomDisplayType === CalendarRoomDisplayType.ROOM_NAME) {
		displayName = Utilities.trim(room.roomName, 15);
	}

	return !!displayName ? <>
		{displayName}
		<span className="ml-1" data-tooltip-id={id}>
				<InformationCircleIcon className="h-4 w-4 cursor-pointer text-blue-400" />
		</span>
		<HotelRoomMappingTooltip id={id}
														 roomMapping={room}
														 openOnClick={false} />
	</> : <div />;
};